import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import ar from './locales/ar.json';
import sw from './locales/sw.json';

const resources = {
  en: { translation: en },
  ar: { translation: ar },
  sw: { translation: sw },
};

const STORAGE_KEY = 'hawrat_lang';
const initialLng =
  (typeof localStorage !== 'undefined' && localStorage.getItem(STORAGE_KEY)) ||
  'en';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLng,
    fallbackLng: 'en',
    supportedLngs: ['en', 'ar', 'sw'],
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });

i18n.on('languageChanged', (lng) => {
  if (typeof localStorage !== 'undefined') localStorage.setItem(STORAGE_KEY, lng);
});

export default i18n;
